module.exports = __webpack_public_path__ + "static/media/world-map.e1dbfe2e.png";